<section class="pull-left w-100">
    <div class="container">
      <div class="row">
        <div class="wrapper min-veight-div" [ngStyle]="{'min-height': contentHeight+'px'}" style="overflow-y:auto">
          <div class="pull-left w-100 search-page">
            <div class="search-box-wrap pull-left w-100 margin-top-50 margin-bottom-30">
              <input id="search" type="text"  (keypress)="charOnly($event)" maxlength="30"  name="searchval" class="item_search" placeholder="Search for movies, songs &amp; more…" value="" #box (keyup.enter)="onHitEnterSearch(box.value, false)" (keyup)="onSearch(box.value)" autocomplete="off">
              <span class="search_errors" *ngIf="searchError">Please enter Search text</span>
              <i (click)="clearSearch()" *ngIf="closeIcon" class="clear">clear</i>
              <img lazyLoad="/assets/tarangplus/icon_close_alert.svg" (click)="closePop()">
            </div>
            <div  *ngIf="recentSearchTags.length > 0 && search_results.length === 0 ">
              <div class="pull-left search-header" >
                <h4 class="margin-bottom-0 oriya-color1 font-size2 medium_16_9">Recent Search</h4>
                <button (click)="clearRecentSearch()" class="clerall-btn">Clear All</button>
              </div>
              <div id="recent-search" class="w-100 pull-left flex flex-row margin-top-10">
                <button *ngFor="let recentItem of recentSearchTags" (click)="hitRecentSearch(recentItem)"  class="recent-search-btn font-size2 margin-left-8">{{recentItem}}</button>
              </div>
            </div>
            <div *ngIf="search_results.length > 0">
              <div class="pull-left w-100 ">
                <h1 class="page-title pull-left w-100 margin-bottom-15" id="search_heading" *ngIf="search_results.length > 0">Search Results(<span class="search_item_cnt">{{search_results.length}}</span>)</h1> 
              </div>
              <div class="thumbnail-list-wrap shows-list-page pull-left inline-block" id="trending_results">			
                <div *ngFor="let s of search_results; index as i;" class="thumbnail-search-list-box margin-bottom-20 relative-content">	
                  <div class="item-image relative-content margin-bottom-10">
                      <a routerLink="{{commonService.getItemURL(s)}}" (click)="onClickSearchResult(s, i)">
                        <img class="img-fluid search" [lazyLoad]="s.thumbnails && s.thumbnails?.medium_16_9 ? s.thumbnails?.medium_16_9?.url : 'https://hls.tarangplus.in/default_images/xl_image_16_9_1920-1080.jpeg'" title="{{s['title']}}">
                        <p class="search-item-title">{{ s.display_title ? s.display_title : s.title }}</p>
                        <!-- <span *ngIf="s['access_control']?.free_label_tag" class="free-txt"><img src="assets/tarangplus/icon_free.svg"></span>
                        <span *ngIf="s['access_control']?.premium_label_tag" class="premium-txt"><img src="assets/tarangplus/tag_premium.svg"></span> -->
                      </a>
                    </div>
                  </div>             
               </div>
            </div>

            
            <div *ngIf="!isshowNoResult" class="w-100">
                <div class="text-center">
                  <img src="./assets/errorMessages/icon_noResultsFound.svg" class="search-error_image" alt="" title="">
                  <p class="margin-bottom-25 text-center font-size3 oriya-color1">Sorry!</p>
                  <p class="margin-bottom-30 text-center oriya-color2 font-size2" style="line-height: 21px;" >We couldn't find anything that <br>matches your search</p>
                  <div class="text-center text-capitalize ">
                    <button (click)="clearSearch()"  class=" font-size2 font-mbold close-search-btn">Clear Search</button>
                  </div>
                </div>
            </div>

            <div *ngIf="trendingSearchResults.length > 0 && search_results.length == 0 && isshowNoResult ">
              <div class="pull-left w-100 ">
                <p class="font-size1 oriya-color1 pull-left w-100 margin-bottom-25" id="trending_search">Trending Search</p>        
              </div>
              <div class=" thumbnail-list-wrap shows-list-page pull-left inline-block" id="trending_results">			
                <div *ngFor="let s of trendingSearchResults; let i=index;" class="thumbnail-search-list-box margin-bottom-20 relative-content">	
                  <div class="item-image relative-content margin-bottom-10">
                      <a routerLink="{{commonService.getItemURL(s)}}" (click)="onClickTrendingSearchResult(s)">
                        <img class="img-fluid search" [lazyLoad]="s.thumbnails && s.thumbnails?.medium_16_9 ? s.thumbnails?.medium_16_9?.url : 'https://hls.tarangplus.in/default_images/xl_image_16_9_1920-1080.jpeg'" title="{{s['title']}}">
                        <!-- <span *ngIf="s['access_control']?.free_label_tag" class="free-txt"><img src="assets/tarangplus/icon_free.svg"></span>
                        <span *ngIf="s['access_control']?.premium_label_tag" class="premium-txt"><img src="assets/tarangplus/tag_premium.svg"></span> -->
                      </a>
                    </div>
                  </div>             
               </div>
            </div>

            <!-- Dangal_Desktop_ATF_970x90_Pub tag.txt -->
            <div *ngIf="banner_ads_available && ads_available && isSubscribedAcc != 'true'" class="dangal-ads-slot1 margin-top-15">
              <div id="banner-ad-search">
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </section>
        